export default __webpack_public_path__ + "static/media/logo.099a7a0a.svg";